import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useI18n } from "@/locales/client";
import { useTRPC } from "@/trpc/client";

export const useResumeSubscription = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const t = useI18n();

  return useMutation(
    trpc.stripe.resumeSubscription.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: trpc.users.getUserPlan.queryKey(),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.users.getPlanLimit.queryKey(),
        });
        toast.success(t("cancellation.toast.resumeSuccess"), {
          description: t("cancellation.toast.resumeSuccessDescription"),
        });
      },
      onError: (error) => {
        console.error("Failed to resume subscription", error);
        toast.error(t("cancellation.toast.resumeError"), {
          description: t("cancellation.toast.resumeErrorDescription"),
        });
      },
    }),
  );
};
